export const upperCaseObjectValues = <T>(obj: T): T => {
  const reduceObject = (elem) =>
    Object.keys(elem).reduce((acc, key) => {
      if (typeof elem[key] === 'string') {
        acc[key] = elem[key].toUpperCase();
      } else {
        acc[key] = elem[key];
      }
      return acc;
    }, {});

  let result;

  if (Array.isArray(obj)) {
    result = [];
    const array = obj;
    array.forEach((elem) => {
      if (typeof obj === 'object') {
        result.push(reduceObject(elem));
      }
    });
  }

  if (typeof obj === 'object' && !Array.isArray(obj)) {
    result = reduceObject(obj);
  }

  return result as T;
};
